import {
    REQUEST_PUT_AWAY,
    FETCH_PUT_AWAY_SUCCESS,
    FETCH_PUT_AWAY_FAILURE,
    RESET_CURRENT_PUT_AWAY,
    REQUEST_CREATING_PUT_AWAY,
    CREATE_PUT_AWAY_SUCCESS,
    CREATE_PUT_AWAY_FAILURE,
    SELECT_PUT_AWAY,
    REQUEST_PUT_AWAY_DETAIL,
    FETCH_PUT_AWAY_DETAIL_SUCCESS,
    FETCH_PUT_AWAY_DETAIL_FAILURE,
    REQUEST_EDITING_PUT_AWAY,
    EDIT_PUT_AWAY_SUCCESS,
    EDIT_PUT_AWAY_FAILURE,
    REQUEST_BIN_LIST_DETAIL,
    FETCH_BIN_LIST_DETAIL_SUCCESS,
    FETCH_BIN_LIST_DETAIL_FAILURE,
    REQUEST_CREATING_BINS,
    CREATE_BINS_SUCCESS,
    CREATE_BINS_FAILURE,
    SELECT_WAREHOUSE_RECEIVE,
    RESET_CURRENT_WAREHOUSE_RECEIVE,
    AUTO_PUTAWAY,
    AUTO_PUTAWAY_SUCCESS,
    AUTO_PUTAWAY_FAILURE
} from '../actions/type'

const INITIAL_STATE = {
  all: [],
  error: null,
  isLoading: false,
  currentPutAway: null,
  putAwayIsCreating: false,
  putAwayCreateError: null,
  putAwayCreated: false,
  currentPutAway: null,
  detailError: null,
  detailIsLoading: false,
  currentPutAwayDetail: null,
  putAwayIsEditing: false,
  putAwayEditError: null,
  putAwayEdited: false,
  isfetchingBinList: false,
  fetchBinListError: null,
  fetchedBinList: null,
  currentWarehouseReceive: null,
  isAutoPutaway: false,
  autoPutawayError: null,
  autoPutawaySuccess: false
};


export default function (state = INITIAL_STATE, action) {
    switch (action.type) {

        // Inventory Adjustment action handlers
        case REQUEST_PUT_AWAY:
            return { ...state, error: null, isLoading: true };
        case FETCH_PUT_AWAY_SUCCESS:
            return { ...state, all: action.payload.data, error: null, isLoading: false };
        case FETCH_PUT_AWAY_FAILURE:
            const error = action.payload || { message: action.payload.message };
            return { ...state, all: [], error: error, isLoading: false };
        case RESET_CURRENT_PUT_AWAY:
            return { ...state, currentPutAway: null, currentPutAwayDetail: null };
        case REQUEST_CREATING_PUT_AWAY:
            return { ...state, putAwayIsCreating: true, putAwayCreateError: null, putAwayCreated: false };
        case CREATE_PUT_AWAY_SUCCESS:
            return { ...state, putAwayIsCreating: false, putAwayCreateError: null, putAwayCreated: true };
        case CREATE_PUT_AWAY_FAILURE:
            const putAwayCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, putAwayIsCreating: false, putAwayCreateError: putAwayCreateError, putAwayCreated: false };
        case SELECT_PUT_AWAY:
            return { ...state, currentPutAway: action.payload };
        case REQUEST_PUT_AWAY_DETAIL:
            return { ...state, detailError: null, detailIsLoading: true };
        case FETCH_PUT_AWAY_DETAIL_SUCCESS:// return list of posts and make loading = false
            return { ...state, currentPutAwayDetail: action.payload.data, detailError: null, detailIsLoading: false };
        case FETCH_PUT_AWAY_DETAIL_FAILURE:// return error and make loading = false
            const detailError = action.payload || { message: action.payload.message };//2nd one is network or server down errors
            return { ...state, all: [], detailError: detailError, detailIsLoading: false };
        case REQUEST_EDITING_PUT_AWAY:
            return { ...state, putAwayIsEditing: true, putAwayEditError: null, putAwayEdited: false };
        case EDIT_PUT_AWAY_SUCCESS:
            return { ...state, putAwayIsEditing: false, putAwayEditError: null, putAwayEdited: true };
        case EDIT_PUT_AWAY_FAILURE:
            const putAwayEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
            return { ...state, putAwayIsEditing: false, putAwayEditError: putAwayEditError, putAwayEdited: false };
        case REQUEST_BIN_LIST_DETAIL:
            return {...state, isfetchingBinList: true, fetchBinListError: null, fetchedBinList: null};
        case FETCH_BIN_LIST_DETAIL_SUCCESS:
            return {...state, isfetchingBinList: false, fetchBinListError: null, fetchedBinList: action.payload.data};
        case FETCH_BIN_LIST_DETAIL_FAILURE:
            const fetchBinListError = action.payload.data || {message: action.payload.message};
            return {...state, isfetchingBinList: false, fetchBinListError: fetchBinListError, fetchedBinList: null};
        case REQUEST_CREATING_BINS:
            return {...state, isfetchingBinList: true, fetchBinListError: null, fetchedBinList: null};
        case CREATE_BINS_SUCCESS:
            return {...state, isfetchingBinList: false, fetchBinListError: null, fetchedBinList: action.payload.data};
        case CREATE_BINS_FAILURE:
            const createBinsError = action.payload.data || {message: action.payload.message};
            return {...state, isfetchingBinList: false, fetchBinListError: createBinsError, fetchedBinList: null};
        case SELECT_WAREHOUSE_RECEIVE:
            return {...state, currentWarehouseReceive: action.payload };
        case RESET_CURRENT_WAREHOUSE_RECEIVE:
            return { ...state, currentWarehouseReceive: null };
        case AUTO_PUTAWAY:
            return {...state, isAutoPutaway: true, autoPutawayError: null, autoPutawaySuccess: false};
        case AUTO_PUTAWAY_SUCCESS:
            return {...state, isAutoPutaway: false, autoPutawayError: null, autoPutawaySuccess: true};
        case AUTO_PUTAWAY_FAILURE:
            const autoPutawayError = action.payload.data || {message: action.payload.message};
            return {...state, isAutoPutaway: false, autoPutawayError: autoPutawayError, autoPutawaySuccess: false};


        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/putAway_reducer.jsx